module.exports = __webpack_public_path__ + "static/img/awardwinner_btn_chi.5b825524.png";